export default "__VITE_ASSET__OMg$ywiT__"